(function () {
  function initHowItWorks(section) {
    if (!section || section.dataset.skyHowReady === 'true') return;
    section.dataset.skyHowReady = 'true';

    var tabs = Array.from(section.querySelectorAll('[data-install-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-install-panel]'));

    function selectDevice(device, moveFocus) {
      tabs.forEach(function (tab) {
        var selected = tab.dataset.installTab === device;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('tabindex', selected ? '0' : '-1');
        if (selected && moveFocus) tab.focus();
      });

      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.installPanel !== device;
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        selectDevice(tab.dataset.installTab, false);
      });

      tab.addEventListener('keydown', function (event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        var next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        selectDevice(tabs[next].dataset.installTab, true);
      });
    });

    section.querySelectorAll('[data-device-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      var dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      var previous = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var status = carousel.querySelector('[data-carousel-status]');
      var activeIndex = 0;
      var scrollFrame;

      if (!track || !slides.length) return;

      function updateControls(index) {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        dots.forEach(function (dot, dotIndex) {
          var selected = dotIndex === activeIndex;
          dot.classList.toggle('is-active', selected);
          if (selected) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (status) status.textContent = (activeIndex + 1) + ' / ' + slides.length;
        if (previous) previous.disabled = activeIndex === 0;
        if (next) next.disabled = activeIndex === slides.length - 1;
      }

      function goTo(index) {
        var target = Math.max(0, Math.min(index, slides.length - 1));
        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: slides[target].offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
        updateControls(target);
      }

      function indexFromScroll() {
        var closest = 0;
        var smallestDistance = Infinity;
        slides.forEach(function (slide, index) {
          var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
          if (distance < smallestDistance) {
            smallestDistance = distance;
            closest = index;
          }
        });
        updateControls(closest);
      }

      track.addEventListener('scroll', function () {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(indexFromScroll);
      }, { passive: true });

      if (previous) previous.addEventListener('click', function () { goTo(activeIndex - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(Number(dot.dataset.carouselDot)); });
      });

      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          track.scrollLeft = slides[activeIndex].offsetLeft;
        }).observe(track);
      }

      updateControls(0);
    });

    section.querySelectorAll('[data-carousel-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var source = trigger.querySelector('img');
        if (!source) return;

        var overlay = document.createElement('div');
        var close = document.createElement('button');
        var image = document.createElement('img');
        var previousOverflow = document.body.style.overflow;

        overlay.className = 'sky-how-lightbox';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', source.alt || 'Installation screenshot');
        close.type = 'button';
        close.setAttribute('aria-label', 'Close enlarged screenshot');
        close.textContent = '×';
        image.src = source.currentSrc || source.src;
        image.alt = source.alt || '';
        overlay.appendChild(close);
        overlay.appendChild(image);
        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        close.focus();

        function closeOverlay() {
          document.removeEventListener('keydown', onKeydown);
          document.body.style.overflow = previousOverflow;
          overlay.remove();
          trigger.focus();
        }

        function onKeydown(event) {
          if (event.key === 'Escape') closeOverlay();
        }

        close.addEventListener('click', closeOverlay);
        overlay.addEventListener('click', function (event) {
          if (event.target === overlay) closeOverlay();
        });
        document.addEventListener('keydown', onKeydown);
      });
    });
  }

  function initAll(scope) {
    if (scope && scope.matches && scope.matches('[data-sky-how]')) initHowItWorks(scope);
    (scope || document).querySelectorAll('[data-sky-how]').forEach(initHowItWorks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
